<div class="mt-2 mb-2 alert alert-warning">
  Указывая данные, Вы подтверждаете, что
  @if (type === 'agent') {
    сотрудник согласен
  } @else if (type === 'client') {
    клиент согласен
  } @else if (type === 'self') {
    согласны
  }
  с обработкой персональных данных (в соответствии с ФЗ №152 «О персональных данных»).
</div>
